<div class="flex flex-col w-full rounded-md">
    <!-- Header -->
    <p>
        <mat-toolbar class="bg-primary">
            <mat-toolbar-row>
                @if(title()) {
                <span class="text-white font-semibold">{{ title() }}</span>
                }
                <span class="flex-auto"></span>
                <a
                    mat-icon-button
                    [matTooltip]="'Close'"
                    (click)="close(false)"
                >
                    <mat-icon class="text-white">close</mat-icon>
                </a>
            </mat-toolbar-row>
        </mat-toolbar>
    </p>
    <div class="relative flex flex-col flex-auto items-start px-6 sm:px-12">
        <div class="w-full max-w-lg mt-8">
            @if(message()) {
            <p>
                {{ message() }}
            </p>
            }
        </div>
    </div>

    <!-- Actions -->
    <div
        class="flex items-center px-6 sm:px-12 mt-10 py-4  border-t bg-gray-50 dark:bg-transparent"
        mat-dialog-actions
    >
        <!-- Cancel -->
        <button
            class="ml-auto"
            mat-button
            [matTooltip]="buttonFalse()"
            (click)="close(false)"
        >
            {{ buttonFalse() }}
        </button>
        <!-- Save -->
        <button
            class="ml-2"
            mat-flat-button
            [color]="'primary'"
            [matTooltip]="buttonTrue()"
            (click)="close(true)"
        >
            {{ buttonTrue() }}
        </button>
    </div>
</div>
